<template>
    <v-container class="pa-4">
        <v-data-table
            :headers="headers"
            :items="managers"
            class="elevation-5"
            :loading="loading"
            :server-items-length="total"
            :page.sync="page"
            @page-count="pageCount = $event"
            @update:page="sync"
            hide-default-footer
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-btn icon @click="back">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-toolbar-title>
                        {{ title }}
                    </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <create-dialog
                        ref="createDialog"
                        :name="resourceName"
                        :fields="fields"
                        :handleCreate="handleCreate"
                        :handleUpdate="handleUpdate"
                    />
                    <confirm-dialog
                        ref="confirmDialog"
                        :handleSubmit="handleDelete"
                    />
                    <input-dialog
                        ref="inputDialog"
                        :fields="resetPasswordFields"
                        :handleSubmit="handleResetPassword"
                    />
                </v-toolbar>
            </template>
            <template v-slot:footer>
                <v-pagination
                    class="py-2"
                    v-model="page"
                    :length="pageCount"
                    :total-visible="7"
                ></v-pagination>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="showUpdateDialog(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small class="mr-2" @click="showResetDialog(item)">
                    mdi-lock-reset
                </v-icon>
                <v-icon small @click="showDeleteDialog(item)">
                    mdi-delete
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';
import CreateDialog from '@/components/dialog/CreateDialog.vue';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import InputDialog from '@/components/dialog/InputDialog.vue';
import OperationMixin from '@/views/mixins/OperationMixin';

export default {
    mixins: [OperationMixin],
    components: {
        CreateDialog,
        ConfirmDialog,
        InputDialog,
    },
    data: () => ({
        resourceName: '帳號',
        headers: [
            { text: '帳號', value: 'account' },
            { text: '名稱', value: 'name' },
            { text: '操作', value: 'actions', sortable: false },
        ],
        fields: [
            {
                name: '名稱', type: 'text', key: 'name', required: true,
            },
            {
                name: 'Email',
                type: 'text',
                key: 'account',
                required: true,
                immutable: true,
                rules: [
                    (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
            },
            {
                name: '密碼', type: 'text', key: 'password', required: true, immutable: true,
            },
        ],
    }),
    computed: {
        ...mapState('manager', ['managers', 'total']),
        title() {
            return 'B級權限管理';
        },
        resetPasswordFields() {
            return _.filter(this.fields, ['key', 'password']);
        },
    },
    methods: {
        ...mapActions('manager', ['fetch', 'create', 'update', 'delete', 'resetPassword']),
        back() {
            this.$router.go(-1);
        },
        showResetDialog(item) {
            this.$refs.inputDialog.show(item);
        },
        async handleResetPassword(data) {
            await this.resetPassword(data);
            this.$showHint('重設成功');
        },
    },
    mounted() {

    },
};
</script>
<style lang="scss" scoped>
.row {
    margin: 12px !important;
}
</style>
